import { useState, forwardRef } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

/**
 * Input password con toggle "mostra/nascondi" (icona occhio) a destra.
 * Supporta un'icona opzionale a sinistra (default: Lock).
 *
 * Esempio:
 *   <PasswordInput value={pw} onChange={e => setPw(e.target.value)}
 *     data-testid="my-password" placeholder="Password" />
 */
const PasswordInput = forwardRef(function PasswordInput(
  {
    className = "input-warm pl-10 pr-10",
    leftIcon: LeftIcon = Lock,
    showLeftIcon = true,
    testIdSuffix,
    ...rest
  },
  ref
) {
  const [visible, setVisible] = useState(false);
  const baseTestId = rest["data-testid"];
  const toggleTestId = testIdSuffix || (baseTestId ? `${baseTestId}-toggle` : "password-toggle");

  return (
    <div className="relative">
      {showLeftIcon && LeftIcon && (
        <LeftIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-tertiary-fg pointer-events-none" />
      )}
      <input
        ref={ref}
        type={visible ? "text" : "password"}
        className={className}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={toggleTestId}
        aria-label={visible ? "Nascondi password" : "Mostra password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-tertiary-fg hover:text-primary-fg transition-colors"
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
